var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { injectable } from '@servicetitan/react-ioc';
import { observable, action, makeObservable } from 'mobx';
let ConnectionService = class ConnectionService {
    constructor() {
        Object.defineProperty(this, "online", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: window.navigator.onLine
        });
        makeObservable(this);
        window.addEventListener('online', () => this.setOnline(true));
        window.addEventListener('offline', () => this.setOnline(false));
    }
    setOnline(status) {
        this.online = status;
    }
};
__decorate([
    observable,
    __metadata("design:type", Boolean)
], ConnectionService.prototype, "online", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ConnectionService.prototype, "setOnline", null);
ConnectionService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], ConnectionService);
export { ConnectionService };
//# sourceMappingURL=connection-service.js.map